import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules, productImage, solutionPoints } from '../data/content';
import { scrollToPricing } from './CTAButton';
export function ModulesSection() {
  return <section className="bg-white px-4 py-5 sm:px-6" aria-labelledby="solution-heading" data-id="element-109" data-mp="1ius3dnhp7jii">
      <div className="mb-3 text-center" data-id="element-110" data-mp="1dx07yjhuhf9k">
        <h2 id="solution-heading" className="mb-1 text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-111" data-mp="1dy1jep2rw3rt">
          The Complete System You've Been Looking For
        </h2>
        <p className="mb-2 text-[11px] font-extrabold uppercase tracking-wide text-brand-teal sm:text-sm" data-id="element-112" data-mp="26jb9pxh6tm7y">
          One Complete 6-in-1 Pickleball Coaching System
        </p>
        <button type="button" onClick={scrollToPricing} className="mb-2 block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Go to the offer section" data-id="element-113" data-mp="1wmq3j8tfm52j">
          <img src={productImage} alt="Pickleball Coach Pro 6-in-1 coaching system" className="mx-auto w-full max-w-[240px] object-contain drop-shadow-lg transition-transform duration-200 hover:scale-[1.02]" data-id="element-114" data-mp="1iv8s81ezc162" />
        </button>
        <p className="text-base font-extrabold uppercase leading-tight text-brand-navy sm:text-xl" data-id="element-115" data-mp="18wt0bw84onvi">
          Pickleball Coach Pro™
        </p>
        <p className="mb-2 text-[11px] font-bold uppercase tracking-wide text-brand-green sm:text-xs" data-id="element-116" data-mp="1050qnnqxhirz">
          The Complete Coaching &amp; Training System
        </p>
        <p className="text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-117" data-mp="14xk3ujlpebw9">
          This isn't another collection of random drills. It's a complete professional system
          designed to help you:
        </p>
        <ul className="mt-1.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-id="element-118" data-mp="h651wrxu9wlj">
          {solutionPoints.map(point => <li key={point} className="text-[11px] font-bold text-brand-navy sm:text-xs" data-id="element-119" data-mp="l66sa4y4j3li">
              ✔ {point}
            </li>)}
        </ul>
      </div>
      <div className="space-y-2" data-id="element-120" data-mp="2j1ucv8o74l94">
        {modules.map(module => <article key={module.title} className="flex gap-2.5 rounded-lg border border-brand-navy/10 bg-brand-cream p-3 shadow-sm" data-id="element-121" data-mp="2e3ki2z6dvmo1">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-green" data-id="element-122" data-mp="36szr5jehn5hb">
              <CheckIcon className="h-3 w-3 text-brand-navy" aria-hidden="true" data-id="element-123" data-mp="31tesla38cz54" />
            </span>
            <div data-id="element-124" data-mp="2wuak6lo4r5fu">
              <h3 className="mb-0.5 text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-125" data-mp="2wtseyzjhpgvs">
                {module.title}
              </h3>
              <p className="text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-126" data-mp="2svl1cdkbovot">
                {module.description}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}